export interface TemplateEntityTypes {
    declarationInternalType: 'IMPORT' | 'IMPORT_NEW' | 'EXPORT' | 'ENS' | 'NCTS';
    declarationExternalEntity: 'REVENUE' | 'CDS' | 'HMRC';
}

type TemplateCountry = 'ireland' | 'uk' | 'eu';
type TemplateInternalType = 'import' | 'export' | 'ens' | 'ncts';

const IRELAND_TYPES: Partial<Record<TemplateInternalType, TemplateEntityTypes>> = {
    import: { declarationInternalType: 'IMPORT', declarationExternalEntity: 'REVENUE' },
    export: { declarationInternalType: 'EXPORT', declarationExternalEntity: 'REVENUE' },
    ncts: { declarationInternalType: 'NCTS', declarationExternalEntity: 'REVENUE' },
    ens: { declarationInternalType: 'ENS', declarationExternalEntity: 'REVENUE' },
};

// The backend stores UK import templates as IMPORT_NEW, which is also what the template list filters on.
const UK_TYPES: Partial<Record<TemplateInternalType, TemplateEntityTypes>> = {
    import: { declarationInternalType: 'IMPORT_NEW', declarationExternalEntity: 'CDS' },
    export: { declarationInternalType: 'EXPORT', declarationExternalEntity: 'CDS' },
    ncts: { declarationInternalType: 'NCTS', declarationExternalEntity: 'HMRC' },
};

const TYPES_BY_COUNTRY: Partial<Record<TemplateCountry, Partial<Record<TemplateInternalType, TemplateEntityTypes>>>> = {
    ireland: IRELAND_TYPES,
    uk: UK_TYPES,
};

export const getTemplateEntityTypes = (
    country: TemplateCountry,
    internalType: TemplateInternalType
): TemplateEntityTypes => {
    const entityTypes = TYPES_BY_COUNTRY[country]?.[internalType];
    if (!entityTypes) {
        throw new Error(`No template type for country "${country}" and declaration type "${internalType}"`);
    }
    return entityTypes;
};
